import type Employee from 'modules/employees/store/models/Employee'
import type LeaveForm from 'modules/timeoff/lib/LeaveForm'

interface Props {
  currentEmployee: Employee | null | undefined
  form: LeaveForm
}

export type Role = 'admin' | 'basic'

const useCurrentEmployeeRole = ({ currentEmployee, form }: Props): Role => {
  // !currentEmployee means is an admin
  if (!currentEmployee) return 'admin'

  const canApprove = currentEmployee.policy.can('approveLeaves')

  if (canApprove || !currentEmployee.timeoffManager || form.isSickType()) {
    return 'admin'
  }

  return 'basic'
}

export default useCurrentEmployeeRole
